import React, { useEffect, useMemo } from 'react';
import { createFilter } from 'react-select';
import Select from '../../../form/Select';
import PERMISSION from '../../../../constants/Permissions';

const REQUIRED_FACILITY_PERMISSIONS = [PERMISSION.FLEX_ADD_EDIT_SHIFT, PERMISSION.FLEX_ADD_CAREGIVER];

const facilityFilterConfig = {
	ignoreCase: true,
	ignoreAccents: true,
	matchFrom: 'any',
	stringify: (option) => option.label.toString(),
	trim: true
};

const isEligibleFacility = (facility, permissionsByFacility) => {
	const granted = (permissionsByFacility || {})[facility.id] || [];
	return REQUIRED_FACILITY_PERMISSIONS.every((code) => granted.includes(code));
};

/**
 * Facility picker for the Add assigned shifts tab.
 *
 * Callers pre-filter `facilities` to the flex-eligible set; this component adds the extra
 * FLEX_ADD_CAREGIVER permission check on top of the implicit FLEX_ADD_EDIT_SHIFT. When exactly
 * one facility passes, auto-selects it on mount — unless `disabled` is true (Daily Schedule locks
 * the dropdown to the active facility, which the parent pre-selects).
 */
const BulkAssignShiftsFacilityPicker = ({
	facilities,
	permissionsByFacility,
	selectedFacility,
	onFacilityChange,
	disabled
}) => {
	const eligibleFacilities = useMemo(
		() => (facilities || []).filter((facility) => isEligibleFacility(facility, permissionsByFacility)),
		[facilities, permissionsByFacility]
	);

	const options = useMemo(() => eligibleFacilities.map((facility) => ({ label: facility.label, value: facility.id })), [
		eligibleFacilities
	]);

	useEffect(() => {
		if (disabled) return;
		if (!selectedFacility && eligibleFacilities.length === 1) {
			onFacilityChange({ facility: eligibleFacilities[0].id });
		}
	}, [eligibleFacilities, disabled, selectedFacility, onFacilityChange]);

	return (
		<Select
			containerClass="bulk-assign-shifts-facility"
			className="request-shifts-modal-select"
			name="facility"
			placeholder="Select..."
			isSearchable
			options={options}
			value={selectedFacility?.id}
			handleChange={onFacilityChange}
			isDisabled={disabled}
			filterFn={createFilter(facilityFilterConfig)}
			noOptionsMessage="No facilities found"
		/>
	);
};

export default BulkAssignShiftsFacilityPicker;
